import { ISignup } from "../pages/auth/Signup/signup.interface";
import { API_Endpoints } from "./API_Endpoints";
import axiosInstance from "./axios";
export const LoginUser = (data: { email: string; password: string }) => {
  return axiosInstance
    .post(API_Endpoints.auth.LOGIN, data)
    .then((res) => res.data)
    .catch((err) => err);
};
export const RegisterUser = (data: ISignup) => {
  return axiosInstance
    .post(API_Endpoints.auth.SIGNUP, data)
    .then((res) => res.data)
    .catch((err) => err);
};

export const SendForgotEmailAddress = (data: { email: string }) => {
  return axiosInstance
    .post(API_Endpoints.auth.SEND_EMAIL, data)
    .then((res) => res.data)
    .catch((err) => err);
};
export const ResetPasswordService = (
  data: {
    new_password: string;
    confirm_password: string;
  },
  id: string
) => {
  return axiosInstance
    .post(`${API_Endpoints.auth.RESET_PASSWORD}/${id}`, data)
    .then((res) => res.data)
    .catch((err) => err);
};

export const UpdateUserProfile = (data: any, id: any) => {
  return axiosInstance
    .put(`${API_Endpoints.auth.UPDATE_USER_PROFILE}/${id}`, data)
    .then((res) => res.data)
    .catch((err) => err);
};
export const ActivateUserAccountService = (id: any, token: any) => {
  return axiosInstance
    .get(`${API_Endpoints.auth.ACTIVATE_USER_ACCOUNT}/${id}/${token}`)
    .then((res) => res.data)
    .catch((err) => err);
};
export const ResendEmailService = (email: string) => {
  return axiosInstance
    .post(`${API_Endpoints.auth.RESEND_EMAIL}`, { email: email })
    .then((res) => res.data)
    .catch((err) => err);
};
